import { useContext, useState } from 'react';
import { SmartContext } from '../../../../library/Core/SmartContext';
import { handleSave } from './BenefitsActions';
import { getDomainValueForCode, getFlexColDomainValueForCode } from '../../../../library/Core/SmartFunctions';
import benefitsStatusesConfig from './benefitsConfig';
import { Tooltip } from 'bootstrap';
import MarketplaceSection from '../../alumni-profile/sections/MarketplaceSection';

const InstituteWiseBenefitsLayout = (props: any) => {
    const { state, dispatch } = useContext(SmartContext);

    const { instituteId, showInstituteName } = props; 

    var tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
            var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                return new Tooltip(tooltipTriggerEl);
            });

    const instituteData = state?.data?.userInstitutes.find((data: any) => data.instituteId == instituteId) || {};
    const instituteName = getDomainValueForCode(instituteId, 'INSTITUTE_DOMAIN', state) || 'Institute Name';
    
    interface FlexColData {
        benefits_status?: Record<string, boolean>;
        prog_duration?: string;
        prog_duration_desc?: string;
        program_level?: string;
    }

    let {exclusiveAlumniPrivilegesKeys, networkingPreferencesKeys} = benefitsStatusesConfig;

    const flexColData = getFlexColDomainValueForCode(instituteId, 'INSTITUTE_DOMAIN', state) as FlexColData | undefined;
    const benefitsStatuses = JSON.parse(flexColData as string)?.benefits_status || {};
    
    const city = getDomainValueForCode(state?.data?.profile?.residingCityCode, 'CITY_CODE', state) || 'City';
    let stalwarts = '';
    let industryId = '';
    if(state?.data?.profile?.workingStatusCode != 'NOT_WORKING') {
        switch(state?.data?.profile?.workingStatusCode) {
            case 'WORKING_FOR_A_COMPANY': 
            industryId = state?.data?.jobs.find((job: any) => job.jobCategory == 'WORKING_FOR_A_COMPANY' && job.isCurrent == true)?.industryCode; 
            break;
            case 'ENTREPRENEURSHIP': 
            industryId = state?.data?.jobs.find((job: any) => job.jobCategory == 'ENTREPRENEURSHIP' && job.isCurrent == true)?.industryCode; 
            break;
            case 'PROFESSIONAL_PRACTICE': 
            industryId = state?.data?.jobs.find((job: any) => job.jobCategory == 'PROFESSIONAL_PRACTICE' && job.isCurrent == true)?.industryCode; 
            break;
            case 'SELF_EMPLOYED_AND_FREELANCING': 
            industryId = state?.data?.jobs.find((job: any) => job.jobCategory == 'SELF_EMPLOYED_AND_FREELANCING' && job.isCurrent == true)?.industryCode; 
            break;
            case 'TEACHING_AND_RESEARCH': 
            industryId = state?.data?.jobs.find((job: any) => job.jobCategory == 'TEACHING_AND_RESEARCH' && job.isCurrent == true)?.industryCode; 
            break;
            case 'IN_DEFENCE': 
            industryId = state?.data?.jobs.find((job: any) => job.jobCategory == 'IN_DEFENCE' && job.isCurrent == true)?.industryCode; 
            break;
        }
        stalwarts = getDomainValueForCode(industryId, 'INDUSTRY_CODE', state) + ' Stalwarts';
    }

    let fieldOfStudyId = '';
    if(state?.data?.profile?.presentEducationStatusCode == 'PURSUING_STUDIES' && stalwarts == '')
    {
        switch(state?.data?.profile?.pursuingEducationLevelCode) {
            case 'UG': 
            fieldOfStudyId = state?.data?.underGradColleges?.find((college: any) => college.recordTypeCode == 'JOINED')?.fieldOfStudyCode; 
            break;
            case 'PG': 
            fieldOfStudyId = state?.data?.postGradCollege?.find((college: any) => college.recordTypeCode == 'JOINED')?.fieldOfStudyCode; 
            break;
            case 'Doctoral': 
            fieldOfStudyId = state?.data?.postGradCollege?.find((college: any) => college.recordTypeCode == 'JOINED')?.fieldOfStudyCode; 
            break;
        }
        stalwarts = getDomainValueForCode(fieldOfStudyId, 'FIELD_OF_STUDY_TYPE_CODE_ALUMNI', state) + ' Students';
    }

    const getBatchFromPassOutYear = (
    passOutYear: number,
    programFlexColData: FlexColData | undefined
    ): string => {
    if (!passOutYear || !programFlexColData) return '';

    const { program_level, prog_duration, prog_duration_desc } = JSON.parse(programFlexColData as string) || {};

    //K12 condition
    if(program_level != 'UG' && program_level != 'PG' && program_level != 'Doctoral') return `${passOutYear - 5} - ${passOutYear + 5}`;

    if (!prog_duration || !prog_duration_desc) return '';

    const durationValue = Number(prog_duration_desc);
    if (isNaN(durationValue) || durationValue <= 0) return '';

    let durationInYears = 0;

    switch (prog_duration) {
        case 'MONTHS':
        durationInYears = durationValue / 12;
        break;
        case 'WEEKS':
        durationInYears = durationValue / 52;
        break;
        case 'DAYS':
        durationInYears = durationValue / 365;
        break;
        default:
        return '';
    }

    const normalizedDurationYears = Math.round(durationInYears);

    const diffYear = 3; // This is the window before and after the pass out year that we consider as active batches

    // Optional: If you ever need program start year
    // const programStartYear = passOutYear - normalizedDurationYears;

    // Active batches window rule
    const activeFromYear = passOutYear - diffYear;
    const activeToYear = passOutYear + diffYear;

    return `${activeFromYear} - ${activeToYear}`;
    };


    let batch = '';
    if(instituteData?.programId && instituteData?.passOutYear) {
        const programFlexColData = getFlexColDomainValueForCode(instituteData?.programId, 'ALL_PROGRAM_CODE', state) as FlexColData | undefined;
        batch = getBatchFromPassOutYear(instituteData?.passOutYear, programFlexColData);
    }
    
    if((industryId == '' || industryId == null) && (fieldOfStudyId == '' || fieldOfStudyId == null)){
        stalwarts = 'Marketing Stalwarts';
    }

    networkingPreferencesKeys = networkingPreferencesKeys.map((key : any) => {
        if (key.id === 'alumniInCity') {
            return { ...key, text: `Alumni in ${city}` };
        }
        if (key.id === 'marketingStalwarts') {
            return { ...key, text: `${stalwarts}` };
        }
        if (key.id === 'batchesActiveDuringMyStay' && batch != '') {
            return { ...key, text: key.text +` (${batch})` };
        }
        return key;
    });

    // if industryId and fieldOfStudyId is empty then remove the marketingStalwarts option from networkingPreferencesKeys
    // if(industryId == '' && fieldOfStudyId == '' && (benefitsStatuses['marketingStalwarts'] == true || networkingPreferencesKeys.find((key: any) => key.id === 'marketingStalwarts')?.isDefault == true)) {
    //     networkingPreferencesKeys = networkingPreferencesKeys.filter((key: any) => key.id !== 'marketingStalwarts');
    // }

    const [userSelectedExclusiveAlumniBenefits, setUserSelectedExclusiveAlumniBenefits] = useState<Record<string, any>>(JSON.parse(instituteData?.benefitsSelection as string || '{}')?.exclusiveAlumniBenefits || exclusiveAlumniPrivilegesKeys.reduce((acc: Record<string, any>, key :any) => {
        acc[key.id] = key.isDefault || false;
        return acc;
    }, {}));

    const handleExclusiveAlumniBenefitsChange = (event: React.ChangeEvent<HTMLInputElement>, benefitId: string) => {
        setUserSelectedExclusiveAlumniBenefits((prevState) => ({
            ...prevState,
            [benefitId]: benefitId === 'others' ? event.target.value : event.target.checked
        }));
    }

    const [userSelectedNetworkingPreferences, setUserSelectedNetworkingPreferences] = useState<Record<string, any>>(JSON.parse(instituteData?.benefitsSelection as string || '{}')?.networkingPreferences || networkingPreferencesKeys.reduce((acc: Record<string, any>, key :any) => {
        acc[key.id] = key.isDefault || false;
        return acc;
    }, {}));

    const handleNetworkingPreferencesChange = (event: React.ChangeEvent<HTMLInputElement>, benefitId: string) => {
        setUserSelectedNetworkingPreferences((prevState) => ({
            ...prevState,
            [benefitId]: benefitId === 'others' ? event.target.value : event.target.checked
        }));
    }

    let [isExlusiveAlumniBenefitsOpened, setIsExclusiveAlumniBenefitsOpened] = useState(true);
    let [isNetworkingPreferencesOpened, setIsNetworkingPreferencesOpened] = useState(true);

    return (
        <>
            <div className="col-12">
                <div className="lite-blue border-radius-6 py-4 px-4">
                    <div className="row g-3">
                        <div className="col-auto">
                            <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/icon-crown.svg`} width="31" alt="" />
                        </div>
                        <div className="col">
                        <div className="font-22 font-600">Exclusive Alumni Privileges{showInstituteName && ` - ${instituteName}`}</div>
                        </div>
                        <div className="col-auto">
                            <button className="bg-transparent border-0 icon-down-arrow fs-4" type="button" data-bs-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample" onClick={() => setIsExclusiveAlumniBenefitsOpened(!isExlusiveAlumniBenefitsOpened)} />
                        </div>
                    </div>
                    <div className={`collapse ${isExlusiveAlumniBenefitsOpened ? 'show' : ''}`} id="collapseExample">
                        <hr className="my-4 border-color-0B34541A opacity-100" />
                        <div className="pb-3">
                            <div className="row g-3">
                        
                            {exclusiveAlumniPrivilegesKeys.map((key: any) => {
                                if(benefitsStatuses[key.id] == true || key.isDefault == true) {
                                    return (
                                    <div className="col-sm-6">
                                        <div className="form-check">
                                            <input className="form-check-input" type="checkbox" id={`check-${key.id}`} 
                                                checked={userSelectedExclusiveAlumniBenefits[key.id] || false} 
                                                onChange={(event) => key.isDefault ? null : handleExclusiveAlumniBenefitsChange(event, key.id)} 
                                            />
                                            <label className="form-check-label d-inline-block font-16 font-500">{key.text}</label>
                                            {key.toolTip && <i className="ms-1 bi bi-info-circle text-dark-blue default-tooltip" key={key.id} data-bs-toggle="tooltip" data-bs-title={key.toolTip} data-bs-original-title={key.toolTip}></i>}
                                        </div>
                                    </div>
                                )}
                                return null;
                            })}
                            
                            <div className="col-sm-12">
                                <div className="row g-3 align-items-center">
                                    <div className="col-auto">
                                        Looking for some other benefits which are not listed above? Don't worry.
                                    </div>
                                    <div className="col">
                                        <input type="text" className="form-control" placeholder="Enter your specific benefit request here" 
                                            value={userSelectedExclusiveAlumniBenefits['others'] || ''}
                                            onChange={(event) => handleExclusiveAlumniBenefitsChange(event, 'others')}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <button className="btn-darkblue mx-auto height-45 mt-2" onClick={(event) => handleSave(event, instituteId, 'exclusiveAlumniBenefits', userSelectedExclusiveAlumniBenefits,  state, dispatch)}>
                                    <span>Update Privileges</span>
                                </button>
                            </div>
                        </div>
                        </div>
                    </div>
                    
                </div>
            </div>

            <div className="col-12">
                <div className="lite-blue border-radius-6 py-4 px-4">
                    <div className="row g-3">
                        <div className="col-auto">
                            <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/icon-teamwork.svg`} className="mt-1" width="31" alt="" />
                        </div>
                        <div className="col">
                            <div className="font-22 font-600">Networking Preferences{showInstituteName && ` - ${instituteName}`}</div>
                            <p className="mb-0">Based on your Journey, we have pre-included you to some of the communities. Please
                                update your networking preferences<br /> for a personalized experience.</p>
                        </div>
                        <div className="col-auto">
                            <button className="bg-transparent border-0 icon-down-arrow fs-4 mt-2" type="button" data-bs-target="#collapseExample1" aria-expanded="true" aria-controls="collapseExample" onClick={() => setIsNetworkingPreferencesOpened(!isNetworkingPreferencesOpened)} />
                        </div>
                    </div>
                    <div className={`collapse ${isNetworkingPreferencesOpened ? 'show' : ''}`} id="collapseExample1">
                        <hr className="my-4 border-color-0B34541A opacity-100" />
                        <div className="pb-3">
                            <div className="row g-3">
                                
                                {networkingPreferencesKeys.map((key: any) => {
                                    if(benefitsStatuses[key.id] == true || key.isDefault == true) {
                                        return (
                                        <div className="col-sm-auto">
                                            <div className="bg-white rounded-pill shadow-sm d-flex align-items-center justify-content-between ps-3 pe-2 py-2 height-50">
                                                <div className="d-flex align-items-center gap-2">
                                                    <img src={`${process.env.REACT_APP_IMAGE_BASEPATH}/${key.img}`} width="16" alt="" />
                                                    <span className="fw-medium">{key.text}</span>
                                                </div>
                                                <div className="form-check form-check-inline p-0 me-0 ms-3">
                                                    <input className="form-check-input moveFunction d-none" type="checkbox" id={key.id} 
                                                        checked={userSelectedNetworkingPreferences[key.id] || false} 
                                                        onChange={(event) => handleNetworkingPreferencesChange(event, key.id)}  
                                                    />
                                                    <label className="form-check-label gap-switch" htmlFor={key.id}></label>
                                                </div>
                                            </div>
                                        </div>
                                        )
                                    }
                                    return null;
                                })}

                                <div className="col-sm-12">
                                <div className="row g-3 align-items-center">
                                    <div className="col-auto">
                                        Didn't find anything that matches your networking preferences?
                                    </div>
                                    <div className="col">
                                        <input type="text" className="form-control" placeholder="Suggest a new community idea..." 
                                            value={userSelectedNetworkingPreferences['others'] || ''}
                                            onChange={(event) => handleNetworkingPreferencesChange(event, 'others')}
                                        />
                                    </div>
                                </div>
                            </div>
            
                                <div className="col-12">
                                    <button className="btn-darkblue mx-auto height-45 mt-2" onClick={(event) => handleSave(event, instituteId, 'networkingPreferences', userSelectedNetworkingPreferences, state, dispatch)}>
                                        <span>Update Preferences</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
            
                </div>
            </div>
            <MarketplaceSection instituteId={instituteId} />
        </>                 
)
};

export default InstituteWiseBenefitsLayout;